export const genUUID = () => Date.now() * Math.random()

export const genStringUUID = (len = 7) => (Math.random() + 1).toString(36).substring(len);